<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-8 col-p h5"><i class="fa fa-globe"></i> Travel Vendor List </div>
                <div class="col-md-6 col-4 top-corner-items col-p">
                    <button class="btn btn-primary btn-sm" [routerLink]="['/dashboard/traval-contract-list']"><i class="fa fa-plus"></i> Add New Vendor</button>
                </div>
            </div>
            <!--end header-->

            
            <div class="row row-replace">
                <section class="col-md-12">
                   <div class="row">
                      <div class="col-md-3 mb7">
                         <label>Select Traval Type</label>
                         <select class="form-control">
                            <option>Type</option>
                            <option>Car</option>
                            <option>Hotal</option>
                            <option>Car with Hotal</option>
                         </select>
                      </div>
                      <div class="col-md-3 mb7">
                         <label>Intra City</label>
                         <select class="form-control">
                            <option>Local</option>
                            <option>Outstation</option>
                         </select>
                      </div>
                      <div class="col-md-3 mb7">
                         <label>From</label>
                         <input type="date" class="form-control">
                      </div>
                      <div class="col-md-3 mb7">
                         <label>To</label>
                         <input type="date" class="form-control">
                      </div>
                   </div>
                   <div class="row">
                      <div class="col-md-12 mb7 text-center">
                         <button class="btn btn-sm btn-success ">Search</button> &nbsp;&nbsp;
                         <button type="button" class="btn btn-sm btn-danger ">Reset</button>
                      </div>
                   </div>
                </section>
             </div>

            
        
            
            <div class="row m-t-30">
                <div class="col-12">
                       <div class="table-responsive">
                           <table class="table">
                               <thead>
                               <tr class="bg-primary text-white">
                                  <th>Sr No.</th>
                                  <th>Contract Type</th>
                                  <th>Car Type</th>
                                  <th>Package Fare</th>
                                  <th>Extra KM</th>
                                  <th>Night Charges</th>
                                  <th>DA/Bhatta</th>
                                  <th>Cancellation TAT</th>
                                  <th>Mini Cancellation Charges</th>
                                  <th>Intra City</th>
                                  <th>Vendor Name</th>
                                  <th>Phone No</th>
                                  <th>Email id</th>
                                  <th>Action</th>
                               </tr>
                            </thead>
                            <tbody>
                             <tr>
                                <td>col1</td>
                                <td>col2</td>
                                <td>col3</td>
                                <td>col4</td>
                                <td>col5</td>
                                <td>col6</td>
                                <td>col7</td>
                                <td>col8</td>
                                <td >col9</td>
                                <td>col10</td>
                                <td>col11</td>
                                <td>col12</td>
                                <td>col13</td>
                                <td>col14</td>
                            </tr>
                            <tr>
                                <td >col1</td>
                                <td>col2</td>
                                <td>col3</td>
                                <td>col4</td>
                                <td>col5</td>
                                <td>col6</td>
                                <td>col7</td>
                                <td>col8</td>
                                <td >col9</td>
                                <td>col10</td>
                                <td>col11</td>
                                <td>col12</td>
                                <td>col13</td>
                                <td>col14</td>
                            </tr>
                            <tr>
                                <td >col1</td>
                                <td>col2</td>
                                <td>col3</td>
                                <td>col4</td>
                                <td>col5</td>
                                <td>col6</td>
                                <td>col7</td>
                                <td>col8</td>
                                <td>col9</td>
                                <td>col10</td>
                                <td>col11</td>
                                <td>col12</td>
                                <td>col13</td>
                                <td>col14</td>
                            </tr>
                            <tr>
                                <td >col1</td>
                                <td>col2</td>
                                <td>col3</td>
                                <td>col4</td>
                                <td>col5</td>
                                <td>col6</td>
                                <td>col7</td>
                                <td>col8</td>
                                <td >col9</td>
                                <td>col10</td>
                                <td>col11</td>
                                <td>col12</td>
                                <td>col13</td>
                                <td>col14</td>
                            </tr>
                            <tr>
                                <td >col1</td>
                                <td>col2</td>
                                <td>col3</td>
                                <td>col4</td>
                                <td>col5</td>
                                <td>col6</td>
                                <td>col7</td>
                                <td>col8</td>
                                <td >col9</td>
                                <td>col10</td>
                                <td>col11</td>
                                <td>col12</td>
                                <td>col13</td>
                                <td>col14</td>
                            </tr>
                            <tr>
                                <td>col1</td>
                                <td>col2</td>
                                <td>col3</td>
                                <td>col4</td>
                                <td>col5</td>
                                <td>col6</td>
                                <td>col7</td>
                                <td>col8</td>
                                <td>col9</td>
                                <td>col10</td>
                                <td>col11</td>
                                <td>col12</td>
                                <td>col13</td>
                                <td>col14</td>
                            </tr>
                            <tr>
                                <td>col1</td>
                                <td>col2</td>
                                <td>col3</td>
                                <td>col4</td>
                                <td>col5</td>
                                <td>col6</td>
                                <td>col7</td>
                                <td>col8</td>
                                <td>col9</td>
                                <td>col10</td>
                                <td>col11</td>
                                <td>col12</td>
                                <td>col13</td>
                                <td>col14</td>
                            </tr>
                            <tr>
                                <td>col1</td>
                                <td>col2</td>
                                <td>col3</td>
                                <td>col4</td>
                                <td>col5</td>
                                <td>col6</td>
                                <td>col7</td>
                                <td>col8</td>
                                <td>col9</td>
                                <td>col10</td>
                                <td>col11</td>
                                <td>col12</td>
                                <td>col13</td>
                                <td>col14</td>
                            </tr>
                            <tr>
                                <td>col1</td>
                                <td>col2</td>
                                <td>col3</td>
                                <td>col4</td>
                                <td>col5</td>
                                <td>col6</td>
                                <td>col7</td>
                                <td>col8</td>
                                <td>col9</td>
                                <td>col10</td>
                                <td>col11</td>
                                <td>col12</td>
                                <td>col13</td>
                                <td>col14</td>
                            </tr>
                            <tr>
                                <td>col1</td>
                                <td>col2</td>
                                <td>col3</td>
                                <td>col4</td>
                                <td>col5</td>
                                <td>col6</td>
                                <td>col7</td>
                                <td>col8</td>
                                <td>col9</td>
                                <td>col10</td>
                                <td>col11</td>
                                <td>col12</td>
                                <td>col13</td>
                                <td>col14</td>
                            </tr>
                            <tr>
                                <td>col1</td>
                                <td>col2</td>
                                <td>col3</td>
                                <td>col4</td>
                                <td>col5</td>
                                <td>col6</td>
                                <td>col7</td>
                                <td>col8</td>
                                <td>col9</td>
                                <td>col10</td>
                                <td>col11</td>
                                <td>col12</td>
                                <td>col13</td>
                                <td>col14</td>
                            </tr>
                            <tr>
                                <td>col1</td>
                                <td>col2</td>
                                <td>col3</td>
                                <td>col4</td>
                                <td>col5</td>
                                <td>col6</td>
                                <td>col7</td>
                                <td>col8</td>
                                <td>col9</td>
                                <td>col10</td>
                                <td>col11</td>
                                <td>col12</td>
                                <td>col13</td>
                                <td>col14</td>
                            </tr>
                            <tr>
                                <td>col1</td>
                                <td>col2</td>
                                <td>col3</td>
                                <td>col4</td>
                                <td>col5</td>
                                <td>col6</td>
                                <td>col7</td>
                                <td>col8</td>
                                <td>col9</td>
                                <td>col10</td>
                                <td>col11</td>
                                <td>col12</td>
                                <td>col13</td>
                                <td>col14</td>
                            </tr>
                            <tr>
                                <td>col1</td>
                                <td>col2</td>
                                <td>col3</td>
                                <td>col4</td>
                                <td>col5</td>
                                <td>col6</td>
                                <td>col7</td>
                                <td>col8</td>
                                <td>col9</td>
                                <td>col10</td>
                                <td>col11</td>
                                <td>col12</td>
                                <td>col13</td>
                                <td>col14</td>
                            </tr>
                            <tr>
                                <td>col1</td>
                                <td>col2</td>
                                <td>col3</td>
                                <td>col4</td>
                                <td>col5</td>
                                <td>col6</td>
                                <td>col7</td>
                                <td>col8</td>
                                <td>col9</td>
                                <td>col10</td>
                                <td>col11</td>
                                <td>col12</td>
                                <td>col13</td>
                                <td>col14</td>
                            </tr>
                            <tr>
                                <td>col1</td>
                                <td>col2</td>
                                <td>col3</td>
                                <td>col4</td>
                                <td>col5</td>
                                <td>col6</td>
                                <td>col7</td>
                                <td>col8</td>
                                <td>col9</td>
                                <td>col10</td>
                                <td>col11</td>
                                <td>col12</td>
                                <td>col13</td>
                                <td>col14</td>
                            </tr>
                            <tr>
                                <td>col1</td>
                                <td>col2</td>
                                <td>col3</td>
                                <td>col4</td>
                                <td>col5</td>
                                <td>col6</td>
                                <td>col7</td>
                                <td>col8</td>
                                <td>col9</td>
                                <td>col10</td>
                                <td>col11</td>
                                <td>col12</td>
                                <td>col13</td>
                                <td>col14</td>
                            </tr>
                            <tr>
                                <td>col1</td>
                                <td>col2</td>
                                <td>col3</td>
                                <td>col4</td>
                                <td>col5</td>
                                <td>col6</td>
                                <td>col7</td>
                                <td>col8</td>
                                <td>col9</td>
                                <td>col10</td>
                                <td>col11</td>
                                <td>col12</td>
                                <td>col13</td>
                                <td>col14</td>
                            </tr>

                            </tbody>
                               
                           </table>
                        </div>
                   </div>
            </div>
             

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->         


